// Styles
import "./message-item.scss";
// Components
import ReactMarkdown from "react-markdown";
// Tools
import { useEffect, useRef } from "react";
import gsap from "gsap";
import { openCampaignCard } from "../../../../../../../../../../shared/utils/bumblebeeTitle";
import { linkifyBareUrls } from "../../../../../../../../../../shared/utils/linkify-bare-urls";
import { unwrapMarkdownFence } from "../../../../../../../../../../shared/utils/unwrap-markdown-fence";

const MESSAGE_TYPE_BUMBLEBEE_WELCOME = "bumblebee.welcome";

interface Props {
	author: string; // user/assistant/system
	message: string;
	date: string;
	messageType?: string;
	campaignId?: string;
	campaignName?: string;
}

export const MessageItem = ({
	author,
	message,
	date,
	messageType,
	campaignId,
	campaignName,
}: Props) => {
	const wrapperRef = useRef(null);
	const isBumblebeeWelcome = messageType === MESSAGE_TYPE_BUMBLEBEE_WELCOME;
	const resolvedCampaignId = campaignId?.trim() ?? "";
	const rawCampaignName = campaignName?.trim() ?? "";
	const resolvedCampaignName =
		rawCampaignName && rawCampaignName !== resolvedCampaignId
			? rawCampaignName
			: "";
	const campaignLinkLabel = resolvedCampaignName
		? `Компанія — ${resolvedCampaignName} — ${resolvedCampaignId}`
		: `Компанія — ${resolvedCampaignId}`;

	useEffect(() => {
		gsap.fromTo(
			wrapperRef.current,
			{
				opacity: 0,
				scale: 0.995,
				y: 4,
			},
			{
				opacity: 1,
				scale: 1,
				y: 0,
				duration: 0.2,
			},
		);
	}, []);

	return (
		<div ref={wrapperRef} className={`message-item ${author}`}>
			<div className={`message-item__wrapper ${author}`}>
				<div className={`message-item__avatar ${author}`}>
					{author === "user" ? (
						<img src='/img/icons/person.png' alt='person' title='Ви' />
					) : author === "system" ? (
						<img src='/img/icons/chat.png' alt='system' title='Система' />
					) : (
						<img src='/img/icons/wand-stars.png' alt='ai' title='Асистент' />
					)}
				</div>
				<div className={`message-item__message ${author}`}>
					<div className='message-item__message-content'>
						<ReactMarkdown
							components={{
								a: ({ node: _node, ...props }) => (
									<a {...props} target='_blank' rel='noreferrer' />
								),
							}}>
							{linkifyBareUrls(unwrapMarkdownFence(message))}
						</ReactMarkdown>
						{isBumblebeeWelcome && resolvedCampaignId && (
							<button
								type='button'
								className='message-item__campaign-link'
								onClick={() => openCampaignCard(resolvedCampaignId)}>
								{campaignLinkLabel}
							</button>
						)}
					</div>
					<div className={`message-item__message-date ${author}`}>{date}</div>
				</div>
			</div>
		</div>
	);
};
